import React, { useState, forwardRef } from "react";

import { Slide, Dialog } from "@material-ui/core";
import configSelector from "common/store/selectors/configSelector";
import GuestCheckout from "./guest-chekout/index.component";
import OtpVerify from "./otp-verification/index.component";
import PhoneVerification from "./phone-verification/index.component";
import SignIn from "./sign-in/index.component";
import SignUp from "./sign-up/index.component";
import AuthDialogHeader from "./auth-dialog-header/index.component";

import "./index.component.scss";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const defaultFormData = {
  fullName: "",
  phone: "",
  email: "",
};

export default function AuthDialog(props) {
  const [formData, setFormData] = useState(defaultFormData);

  // props
  const {
    config,
    activeAuthView,
    isAuthDialogOpen,
    authResponse,
    isMobileView,
    upsdk,
  } = props;

  // callbacks
  const {
    hideAuthDialogCallback,
    forgotPasswordClickCallback,
    loginClickCallback,
    signUpClickCallback,
    resendOtpClickCallback,
    userLoginSuccessCallback,
    userLoginFailureCallback,
    userSignupSuccessCallback,
    userSignupFailureCallback,
    phoneVerifyContinueCallback,
    socialLoginSuccessCallback,
    socialSignUpSuccessCallback,
    guestCheckoutCallback,
    guestCheckoutSuccessCallback,
    handleSetView,
    setAuthResponse,
    setActiveAuthFlow,
  } = props;

  const primaryColor = configSelector.getPrimaryColor({ config });
  const secondaryColor = configSelector.getSecondaryColor({ config });
  const tertiaryColor = configSelector.getTertiaryColor({ config });
  const primaryTextColor = configSelector.getPrimaryTextColor({ config });
  const secondaryTextColor = configSelector.getSecondaryTextColor({ config });
  const primaryLogin = configSelector.getPrimaryLogin({ config });

  const renderActiveAuthView = (activeAuthView) => {
    switch (activeAuthView) {
      case "signIn":
        return (
          <SignIn
            {...props}
            authResponse={authResponse}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            primaryTextColor={primaryTextColor}
            secondaryTextColor={secondaryTextColor}
            handleSetView={handleSetView}
            setAuthResponse={setAuthResponse}
            hideAuthDialogCallback={hideAuthDialogCallback}
            userLoginSuccessCallback={userLoginSuccessCallback}
            userLoginFailureCallback={userLoginFailureCallback}
            setActiveAuthFlow={setActiveAuthFlow}
            primaryLogin={primaryLogin}
            formData={formData}
            setFormData={setFormData}
            signUpClickCallback={(signUpView) =>
              signUpClickCallback(signUpView)
            }
            guestCheckoutCallback={(guestCheckoutView) =>
              guestCheckoutCallback(guestCheckoutView)
            }
            socialLoginSuccessCallback={(socialUserSession) =>
              socialLoginSuccessCallback(socialUserSession)
            }
            forgotPasswordClickCallback={(forgotPasswordView) =>
              forgotPasswordClickCallback(forgotPasswordView)
            }
          />
        );
      case "signUp":
        return (
          <SignUp
            {...props}
            authResponse={authResponse}
            primaryColor={primaryColor}
            setActiveAuthFlow={setActiveAuthFlow}
            secondaryColor={secondaryColor}
            tertiaryColor={tertiaryColor}
            primaryTextColor={primaryTextColor}
            secondaryTextColor={secondaryTextColor}
            setAuthResponse={setAuthResponse}
            primaryLogin={primaryLogin}
            formData={formData}
            setFormData={setFormData}
            userSignupSuccessCallback={userSignupSuccessCallback}
            userSignupFailureCallback={userSignupFailureCallback}
            loginClickCallback={(signInView) => loginClickCallback(signInView)}
            socialSignUpSuccessCallback={(socialUserSession) =>
              socialSignUpSuccessCallback(socialUserSession)
            }
          />
        );
      case "otpVerify":
        return (
          <OtpVerify
            {...props}
            authResponse={authResponse}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            primaryTextColor={primaryTextColor}
            secondaryTextColor={secondaryTextColor}
            handleSetView={handleSetView}
            primaryLogin={primaryLogin}
            resendOtpClickCallback={resendOtpClickCallback}
            hideAuthDialogCallback={hideAuthDialogCallback}
          />
        );
      case "phoneVerify":
        return (
          <PhoneVerification
            {...props}
            authResponse={authResponse}
            primaryColor={primaryColor}
            primaryTextColor={primaryTextColor}
            secondaryTextColor={secondaryTextColor}
            formData={formData}
            setFormData={setFormData}
            setAuthResponse={setAuthResponse}
            handleSetView={handleSetView}
            primaryLogin={primaryLogin}
            userSignupSuccessCallback={userSignupSuccessCallback}
            userSignupFailureCallback={userSignupFailureCallback}
            phoneVerifyContinueCallback={(data) =>
              phoneVerifyContinueCallback(data)
            }
          />
        );
      case "guestCheckout":
        return (
          <GuestCheckout
            t={props.t}
            config={config}
            upsdk={upsdk}
            authResponse={authResponse}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            tertiaryColor={tertiaryColor}
            primaryTextColor={primaryTextColor}
            secondaryTextColor={secondaryTextColor}
            guestCheckoutSuccessCallback={(data) =>
              guestCheckoutSuccessCallback(data)
            }
            hideAuthDialogCallback={hideAuthDialogCallback}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Dialog
      open={isAuthDialogOpen}
      fullScreen={isMobileView}
      aria-labelledby="auth-dialog"
      onClose={hideAuthDialogCallback}
      TransitionComponent={Transition}
      classes={{
        paper: `auth-dialog ${
          isMobileView ? "dialog-without-radius" : "dialog-with-radius"
        }`,
      }}
      disableScrollLock={true}
    >
      <>
        <AuthDialogHeader
          primaryColor={primaryColor}
          primaryTextColor={primaryTextColor}
          hideAuthDialogCallback={hideAuthDialogCallback}
          activeAuthView={activeAuthView}
        />
        {renderActiveAuthView(activeAuthView)}
      </>
    </Dialog>
  );
}
